import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Spacer = (props) => {
  const { size, divider } = props;
  const component = divider ? 'divider' : 'spacer';
  return <div className={classNames(component, `${component}--${size}`)} />;
};

Spacer.defaultProps = {
  divider: null,
  size: null,
};

Spacer.propTypes = {
  divider: PropTypes.bool,
  size: PropTypes.string,
};

export default Spacer;
